import type { MbcAdminGuideline } from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { mbcAdminKeys } from "@/hooks/queryKeys";

import type { InputOf } from "../../useMbcAdminMutation";

import { useMbcAdminMutation } from "../../useMbcAdminMutation";
import { saveGuideline } from "../api";

export function useSaveGuideline(): UseMutationResult<
  MbcAdminGuideline,
  Error,
  InputOf<typeof saveGuideline>
> {
  return useMbcAdminMutation(saveGuideline, mbcAdminKeys.guidelines());
}
